/**
 * CREATIVE DETONATOR - Forgot Password Page Logic (Feature Location)
 *
 * Handles password reset email requests.
 */

import { supabase } from './client.js';

// ============================================================================
// DOM ELEMENTS
// ============================================================================

const form = document.getElementById('forgot-form');
const emailInput = document.getElementById('email');
const errorEl = document.getElementById('error-message');
const successEl = document.getElementById('success-message');
const submitBtn = document.getElementById('submit-btn');

// ============================================================================
// UI HELPERS
// ============================================================================

function showError(message) {
  errorEl.textContent = message;
  errorEl.classList.remove('hidden');
  successEl.classList.add('hidden');
}

function showSuccess(message) {
  successEl.textContent = message;
  successEl.classList.remove('hidden');
  errorEl.classList.add('hidden');
}

function hideMessages() {
  errorEl.classList.add('hidden');
  successEl.classList.add('hidden');
}

function setLoading(loading) {
  submitBtn.disabled = loading;
  submitBtn.classList.toggle('loading', loading);
}

// ============================================================================
// FORM SUBMISSION
// ============================================================================

form.addEventListener('submit', async (e) => {
  e.preventDefault();
  hideMessages();

  const email = emailInput.value.trim();

  // Validation
  if (!email) {
    showError('Please enter your email address.');
    emailInput.focus();
    return;
  }

  setLoading(true);

  try {
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/features/auth/pages/reset-password.html`
    });

    if (error) {
      throw error;
    }

    // Success - show message
    showSuccess('Password reset link sent! Check your email inbox (and spam folder).');
    form.reset();

    console.log('[ForgotPassword] Reset email sent');

  } catch (error) {
    console.error('[ForgotPassword] Error:', error);

    // Don't reveal if email exists or not (security)
    if (error.message.includes('rate limit')) {
      showError('Too many requests. Please wait a few minutes and try again.');
    } else {
      showSuccess('If an account with that email exists, you will receive a reset link.');
    }
  } finally {
    setLoading(false);
  }
});

// ============================================================================
// AUTO-FOCUS EMAIL INPUT
// ============================================================================

emailInput.focus();
